import React, { Component } from 'react'
import { Modal, Tabs } from 'antd'
import StatementForm from './StatementForm'
import Documents from '../../Common/Documents/DocumentsCont'
import FooterButton from '../../../elements/Buttons/FooterButtons'

const { TabPane } = Tabs

class StatementModal extends Component {
  render() {
    const {
      visible,
      type,
      statement,
      onCancel,
      fetchingStatement,
      submitting,
      create,
      update,
      remove,
      removing,
      formRef,
    } = this.props
    return (
      <Modal
        title={'Record Statement'}
        visible={visible}
        onCancel={onCancel}
        destroyOnClose={true}
        width={'95%'}
        footer={
          <FooterButton
            isEdit={type === 'edit'}
            isNew={type === 'new'}
            visible={
              type === 'new' || statement.status === 'Submitted' || statement.status === 'Draft'
            }
            remove={remove}
            removing={removing}
            submit={create}
            submitting={submitting}
            update={update}
            title={'statement'}
          />
        }>
        <Tabs defaultActiveKey="form">
          <TabPane tab="Form" key="form">
            <StatementForm
              ref={formRef}
              loading={fetchingStatement}
              statement={statement}
              {...this.props}
            />
          </TabPane>
          <TabPane disabled={type !== 'edit'} tab="Files" key="files">
            <Documents
              editable={['Submitted', 'Draft'].includes(statement.status)}
              footer={false}
              category={false}
              owner={statement}
              loading={fetchingStatement}
            />
          </TabPane>
        </Tabs>
      </Modal>
    )
  }
}

StatementModal.propTypes = {}
StatementModal.defaultProps = { statement: {} }

export default StatementModal
